import { createSelectorHooks } from 'auto-zustand-selectors-hook';
import _ from 'lodash';
import { create, StoreApi, UseBoundStore } from 'zustand';

import { LocaleState } from 'scbk-services/types/config/config-types';
import { Languages } from '../enums/languages';

let storeInstance: UseBoundStore<StoreApi<LocaleState>> | null = null;

const createStore = () =>
    create<LocaleState>()((set, get) => ({
        instanceId: Math.random().toString(36).substring(2, 15),
        currentLocale: Languages.KO,

        setLocale: (locale: Languages) => set({ currentLocale: locale }),

        getLocale: () => get().currentLocale,
    }));

const useLocaleStore = (() => {
    if (_.isEmpty(storeInstance)) {
        storeInstance = createStore();
    }
    //console.log('useLocaleStore - instanceId', storeInstance?.getState().instanceId);
    return createSelectorHooks(storeInstance!);
})();

export { useLocaleStore };
